import { Card, Col, Collapse, Divider, Row } from 'antd';
import { observer } from 'mobx-react-lite';
import React, { FC, useState } from 'react';
import styled from 'styled-components';
import {
  ContentLink,
  ContentSmallCamptonBookWeight475Grey,
  H5CamptonBold30
} from '../../../../layout/globalFonts';
import ContentStore from '../../../../stores/ContentStore';
import { ProductInfo } from '../../../../swagger/api';
import GoToTransactionsAndUsageButtonRow from './GoToTransactionsAndUsageButtonRow';
// eslint-disable-next-line import/no-cycle
import TransactionsAndUsageTableMobile from '../../../transaction-features/transactions-and-usage/TransactionsAndUsageTableMobile';
import useFetchListDataWithFunctionParameters from '../../../../hooks/fetchDataHooks/useFetchListDataWithFunctionParameters';
import LoadingSpinner from '../../../../common-components/LoadingSpinner';

const CollapseCards = styled(Collapse)`
  width: 100%;
  .ant-collapse-header {
    cursor: pointer !important;
    margin-top: 25px;
    padding: 0px 20px !important;
  }

  .ant-collapse-content-box {
    padding: 0px !important;
  }

  .ant-collapse-header-text {
    width: 100%;
  }
`;

const DividerLine = styled(Divider)`
  margin: 0px 0px 0px -20px;
  background-color: #e0e0e0;
  height: 1px;
`;

const TableTitleRow = styled(Row)`
  margin: 34px 0px 16px 0px;
`;

const SectionCard = styled(Card)`
  margin-bottom: 24px;
  border: none;

  .ant-card-head {
    border-bottom: 2px solid #e9ecef;
    padding-left: 0;
  }

  .ant-card-body {
    padding: 0;
  }

  .ant-card-head-title {
    font-weight: 600;
    font-size: 18px;
    color: #2d2d2d;
    padding-bottom: 25px;
  }
`;

const CustomH5CamptonBold = styled(H5CamptonBold30)`
  @media (max-width: 1000px) {
    font-size: 26px;
  }
`;

interface TransactionAndUsageCollapsableProps {
  contentStore: ContentStore;
  productInfo: ProductInfo;
}

const TransactionAndUsageCollapsable: FC<TransactionAndUsageCollapsableProps> = (props) => {
  const { contentStore, productInfo } = props;
  const { transactionsStore } = contentStore.rootStore;
  const [foldText, setFoldText] = useState<string>('ViewTrips');

  const isLoading = useFetchListDataWithFunctionParameters(
    transactionsStore.identifierTransactions,
    true,
    transactionsStore.getIdentifierTransactions,
    productInfo.identifierId!
  );

  const changeFoldText = () =>
    foldText === 'ViewTrips' ? setFoldText('HideTrips') : setFoldText('ViewTrips');

  const panelHeader = (
    <Row align="middle">
      <Col>
        <CustomH5CamptonBold>
          {contentStore.cmsStore.getContent('Trips')?.content}
        </CustomH5CamptonBold>
      </Col>
      <Col flex="auto" />
      <Col>
        <ContentLink>{contentStore.cmsStore.getContent(foldText)?.content}</ContentLink>
      </Col>
    </Row>
  );

  const noTripsRow = (
    <>
      <DividerLine />
      <TableTitleRow justify="center" gutter={12}>
        <Row>
          <ContentSmallCamptonBookWeight475Grey>
            {contentStore.cmsStore.getContent('NoTripsOnTheProduct')?.content}
          </ContentSmallCamptonBookWeight475Grey>
        </Row>
      </TableTitleRow>
      <DividerLine />
    </>
  );

  const recentTransactions = transactionsStore.identifierTransactions.slice(0, 6);

  return (
    <Row style={{ padding: '0 20px' }}>
      <SectionCard style={{ width: '100%' }}>
        <CollapseCards ghost onChange={changeFoldText}>
          <Collapse.Panel header={panelHeader} showArrow={false} key="1">
            {transactionsStore.identifierTransactions.length === 0 ? (
              isLoading ? (
                <LoadingSpinner />
              ) : (
                noTripsRow
              )
            ) : (
              <TransactionsAndUsageTableMobile
                contentStore={contentStore}
                transactions={recentTransactions}
                showOutstandingOnly={false}
                isTableOnProductCard
                transactionsStore={transactionsStore}
                isLoading={isLoading}
              />
            )}
            <GoToTransactionsAndUsageButtonRow
              contentStore={contentStore}
              transactionsStore={transactionsStore}
            />
          </Collapse.Panel>
        </CollapseCards>
      </SectionCard>
    </Row>
  );
};
export default observer(TransactionAndUsageCollapsable);
